import clsx from 'clsx';
import React from 'react';

import styles from './ThreeDots.module.scss';

interface ThreeDotsProps {
  className?: string;
}

export const ThreeDots = ({ className }: ThreeDotsProps) => {
  return (
    <div
      data-testid="three-dots"
      className={clsx(styles.root, className)}
    >
      <div className={styles.dot} />
      <div className={styles.dot} />
      <div className={styles.dot} />
    </div>
  );
};
